import React from 'react';
import styles from './header.module.css';
import {useSelector, useDispatch} from 'react-redux';

import Logo from './logo/logo.js';
import Faq from './faq/faq.js';
import News from './news/news.js';
import Contacts from './contacts/contacts.js';
import Login from './login/login.js';


const Header = () => {

    return (
        <>
            <div className={styles.wrap}>
                <div className={styles.content}>
                    <Logo />
                    <Faq />
                    <News />
                    <Contacts />
                    <Login />
                </div>
            </div>
        </>
    )
}

export default Header;